import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Activities from './pages/Activities';
import Conferences from './pages/Conferences';
import Summercamp from './pages/Summercamp';
import MeetAndLearn from './pages/MeetAndLearn';
import TaskGroups from './pages/TaskGroups';
import ExecutiveTaskGroup from './pages/ExecutiveTaskGroup';
import InternationalCooperationTaskGroup from './pages/InternationalCooperationTaskGroup';
import ResearchTaskGroup from './pages/ResearchTaskGroup';
import TheoryTaskGroup from './pages/TheoryTaskGroup';
import PsychotherapyTaskGroup from './pages/PsychotherapyTaskGroup';
import ConferenceTaskGroup from './pages/ConferenceTaskGroup';
import AdvisoryTaskGroup from './pages/AdvisoryTaskGroup';
import PRTaskGroup from './pages/PRTaskGroup';
import Research from './pages/Research';
import Definition from './pages/Definition';
import ResearchGrant from './pages/ResearchGrant';
import SFResearch from './pages/SFResearch';
import Membership from './pages/Membership';
import Awards from './pages/Awards';
import Contact from './pages/Contact';
import AdminMeetLearnLogin from './pages/AdminMeetLearnLogin';
import AdminMeetLearnDashboard from './pages/AdminMeetLearnDashboard';
import AdminConferenceLogin from './pages/AdminConferenceLogin';
import AdminConferenceDashboard from './pages/AdminConferenceDashboard';

// Initialize Google Analytics
ReactGA.initialize('G-M139XX8147');

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return (
    <div className="App">
      <Header />
      <main>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/conferences" element={<Conferences />} />
            <Route path="/summercamp" element={<Summercamp />} />
            <Route path="/meet-and-learn" element={<MeetAndLearn />} />
            <Route path="/task-groups" element={<TaskGroups />} />
            <Route path="/taskgroups/executive" element={<ExecutiveTaskGroup />} />
            <Route path="/taskgroups/international-cooperation" element={<InternationalCooperationTaskGroup />} />
            <Route path="/taskgroups/research" element={<ResearchTaskGroup />} />
            <Route path="/taskgroups/theory" element={<TheoryTaskGroup />} />
            <Route path="/taskgroups/psychotherapy" element={<PsychotherapyTaskGroup />} />
            <Route path="/taskgroups/conference" element={<ConferenceTaskGroup />} />
            <Route path="/taskgroups/advisory" element={<AdvisoryTaskGroup />} />
            <Route path="/taskgroups/pr" element={<PRTaskGroup />} />
            <Route path="/research" element={<Research />} />
            <Route path="/research/definition" element={<Definition />} />
            <Route path="/research/grant" element={<ResearchGrant />} />
            <Route path="/sf-research" element={<SFResearch />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/meet-learn" element={<AdminMeetLearnLogin />} />
            <Route path="/admin/meet-learn/dashboard" element={<AdminMeetLearnDashboard />} />
            <Route path="/admin/conference" element={<AdminConferenceLogin />} />
            <Route path="/admin/conference/dashboard" element={<AdminConferenceDashboard />} />
          </Routes>
        </main>
        <Footer />
      </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
